import { AdminModule } from '@modules/auth/models/user-auth.model';
import { FuseNavigation } from '@shared/@fuse/types';

export const nav: FuseNavigation[] = [
    {
        id: 'customer',
        title: 'nav.customer',
        type: 'collapsable',
        icon: 'people',
        children: [
            {
                id: AdminModule.Account,
                title: 'nav.accounts',
                type: 'item',
                url: '/customer/account'
            },
            {
                id: AdminModule.Contact,
                title: 'nav.contacts',
                type: 'item',
                url: '/customer/contact'
            },
            {
                id: AdminModule.User,
                title: 'nav.users',
                type: 'item',
                exactMatch: true,
                url: '/customer/user'
            },
            {
                id: AdminModule.Upgrade,
                title: 'nav.upgrade',
                type: 'item',
                exactMatch: true,
                url: '/customer/user/upgrade'
            },
            {
                id: AdminModule.Document,
                title: 'nav.identity_document',
                type: 'item',
                url: '/setting/identity-document'
            }
        ]
    },
    {
        id: 'trading',
        type: 'collapsable',
        title: 'nav.trading_accounts',
        icon: 'swap_horizontal_circle',
        children: [
            {
                id: AdminModule.TradingAccount,
                title: 'nav.trading_accounts',
                type: 'item',
                url: '/trading-account/account'
            },
            {
                id: AdminModule.TradingAccountRequest,
                title: 'nav.trading_account_request',
                type: 'item',
                url: '/trading-account/request'
            }
        ]
    },
    {
        id: 'fund-management',
        title: 'nav.fund_management',
        type: 'collapsable',
        icon: 'payment',
        children: [
            {
                id: AdminModule.Deposit,
                title: 'nav.deposits',
                type: 'item',
                url: '/deposit'
            },
            {
                id: AdminModule.Withdrawal,
                title: 'nav.withdrawal',
                type: 'item',
                url: '/withdrawal'
            },
            {
                id: AdminModule.Transfer,
                title: 'nav.transfer',
                type: 'item',
                url: '/transfer'
            },
            {
                id: AdminModule.B2BTransfer,
                title: 'nav.b2b_transfer',
                type: 'item',
                url: '/b2b-transfer'
            },
            {
                id: 'funding-method',
                title: 'nav.funding_methods',
                type: 'collapsable',
                children: [
                    {
                        id: AdminModule.CreditCard,
                        title: 'nav.credit_cards',
                        type: 'item',
                        url: '/funding-method/credit-card'
                    },
                    {
                        id: AdminModule.UnionPayCard,
                        title: 'nav.union_pay_cards',
                        type: 'item',
                        url: '/funding-method/union-pay-card'
                    },
                    {
                        id: AdminModule.BankAccount,
                        title: 'nav.bank_account',
                        type: 'item',
                        url: '/funding-method/bank-card'
                    },
                    {
                        id: AdminModule.Fasapay,
                        title: 'nav.fasapay',
                        type: 'item',
                        url: '/funding-method/fasapay'
                    },
                    {
                        id: AdminModule.Poli,
                        title: 'nav.poli',
                        type: 'item',
                        url: '/funding-method/poli'
                    },
                    {
                        id: AdminModule.Skrill,
                        title: 'nav.skrill',
                        type: 'item',
                        url: '/funding-method/skrill'
                    },
                    {
                        id: AdminModule.XpayThai,
                        title: 'nav.xpay_thai',
                        type: 'item',
                        url: '/funding-method/xpay-thai'
                    }
                ]
            },
            {
                id: AdminModule.Payout,
                title: 'nav.payouts',
                type: 'item',
                url: '/monitoring/payout/list'
            },
            {
                id: 'repair',
                title: 'nav.repair',
                type: 'collapsable',
                children: [
                    {
                        id: AdminModule.JarvisDepositRepair,
                        title: 'nav.jarvis',
                        type: 'item',
                        url: '/repair/jarvis'
                    },
                    {
                        id: AdminModule.RPNDepositRepair,
                        title: 'nav.rpn',
                        type: 'item',
                        url: '/repair/rpn'
                    },
                    {
                        id: AdminModule.PayQuayDepositRepair,
                        title: 'nav.payquay',
                        type: 'item',
                        url: '/repair/payquay'
                    },
                    {
                        id: AdminModule.T365DepositRepair,
                        title: 'nav.t365',
                        type: 'item',
                        url: '/repair/t365'
                    }
                ]
            }
        ]
    },
    {
        id: AdminModule.Leverage,
        title: 'nav.leverage',
        type: 'item',
        url: '/leverage',
        icon: 'forum'
    },
    {
        id: AdminModule.Reward,
        title: 'nav.rewards',
        type: 'item',
        icon: 'card_giftcard',
        url: '/rewards'
    },
    {
        id: AdminModule.Promotions,
        title: 'nav.promotions',
        type: 'item',
        icon: 'brightness_5',
        url: '/promotions'
    },
    {
        id: AdminModule.IB,
        title: 'nav.internal_broker',
        type: 'item',
        icon: 'local_atm',
        url: '/internal-brokers'
    },
    {
        id: AdminModule.Partners,
        title: 'nav.partners',
        type: 'item',
        icon: 'groups',
        url: '/partners'
    },
    {
        id: 'report',
        title: 'nav.report',
        type: 'collapsable',
        icon: 'report',
        children: [
            {
                id: AdminModule.ReportSymbol,
                title: 'nav.symbol',
                type: 'item',
                url: '/report/symbol'
            },
            {
                id: AdminModule.ReportTrade,
                title: 'nav.trade',
                type: 'item',
                url: '/report/trade'
            },
            {
                id: AdminModule.ReportSales,
                title: 'nav.sales',
                type: 'item',
                url: '/report/sales'
            }
        ]
    },
    {
        id: 'monitoring',
        title: 'nav.monitoring',
        type: 'collapsable',
        icon: 'remove_from_queue',
        children: [
            {
                id: AdminModule.WatchDog,
                title: 'nav.watchdog',
                type: 'item',
                url: '/monitoring/watchdog/watchlist'
            },
            {
                id: AdminModule.FingerPrint,
                title: 'nav.fingerprint',
                type: 'item',
                url: '/monitoring/watchdog/fingerprint'
            },
            {
                id: AdminModule.RequestFingerprint,
                title: 'nav.request_fingerprint',
                type: 'item',
                url: '/monitoring/watchdog/request-list'
            }
        ]
    },
    {
        id: 'bulk-operations',
        title: 'nav.special_features',
        type: 'collapsable',
        icon: 'stars',
        children: [
            {
                id: AdminModule.FundOperation,
                title: 'nav.funds',
                type: 'item',
                url: '/bulk-operation/fund'
            },
            {
                id: AdminModule.CreditToBalanceOperation,
                title: 'nav.credit_to_balance',
                type: 'item',
                url: '/bulk-operation/credit-to-balance'
            },
            {
                id: AdminModule.GoodwillOperation,
                title: 'nav.good_will',
                type: 'item',
                url: '/bulk-operation/good-will'
            },
            {
                id: AdminModule.GoodwillOperation,
                title: 'nav.swaps',
                type: 'item',
                url: '/bulk-operation/swaps'
            },
            {
                id: 'payout-sheets',
                title: 'nav.payout_sheets',
                type: 'collapsable',
                children: [
                    {
                        id: AdminModule.XPayOperation,
                        title: 'nav.xpay',
                        type: 'item',
                        url: '/payout-sheets/xpay'
                    },
                    {
                        id: AdminModule.XPayThaiOperation,
                        title: 'nav.xpay_thai',
                        type: 'item',
                        url: '/payout-sheets/xpay-thai'
                    }
                ]
            },
            {
                id: AdminModule.IBCreditTransferOperation,
                title: 'nav.ib_credit_transfer',
                type: 'item',
                url: '/bulk-operation/transfer'
            },
            {
                id: AdminModule.BulkTransfer,
                title: 'nav.bulk_transfer',
                type: 'item',
                url: '/bulk-operation/bulk-transfer'
            }
        ]
    },
    {
        id: 'compliance',
        title: 'nav.compliance',
        type: 'collapsable',
        icon: 'school',
        children: [
            {
                id: AdminModule.NovationRequests,
                title: 'nav.novation_requests',
                type: 'item',
                url: '/compliance/novation-requests'
            },
            {
                id: AdminModule.CountryLicences,
                title: 'nav.country_licences',
                type: 'item',
                url: '/compliance/country-licences'
            },
            {
                id: AdminModule.DocumentManagement,
                title: 'nav.document_management',
                type: 'item',
                url: '/compliance/document-management'
            }
        ]
    },
    {
        id: 'settings',
        title: 'nav.settings',
        icon: 'settings',
        type: 'collapsable',
        children: [
            {
                id: AdminModule.TradingAccountGroup,
                title: 'nav.trading_account_groups',
                type: 'item',
                url: '/setting/trading-account-group'
            },
            {
                id: AdminModule.PaymentGateway,
                title: 'nav.payment_gateway',
                type: 'item',
                url: '/setting/gateway'
            },
            {
                id: AdminModule.LookupManagement,
                title: 'nav.lookup_management',
                type: 'item',
                url: '/setting/lookup-management'
            }
        ]
    }
];
